module.exports = __webpack_public_path__ + "img/title.7d8f1014.png";